var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.article
    ? _c("div", { staticClass: "bulletin-container" }, [
        _c("header", [
          _c("h1", [_vm._v("\n      " + _vm._s(_vm.article.title) + "\n    ")]),
          _c("div", { staticClass: "article-info" }, [
            _c(
              "div",
              { staticClass: "article-categories" },
              _vm._l(_vm.article.categories, function(category) {
                return _c("a-tag", { key: category.id }, [
                  _vm._v("\n          " + _vm._s(category.name) + "\n        ")
                ])
              }),
              1
            ),
            _c("div", [
              _vm._v(
                "Közzétéve: " +
                  _vm._s(
                    _vm
                      .moment(_vm.article.date)
                      .format("YYYY.MM.DD")
                      .toString()
                  )
              )
            ]),
            _vm.article.deadlineDate
              ? _c("div", [
                  _vm._v("\n        Határidő:\n        "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm
                          .moment(_vm.article.deadlineDate)
                          .format("YYYY.MM.DD")
                          .toString()
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm.article.mandatory
              ? _c(
                  "div",
                  { staticClass: "mandatory" },
                  [
                    _c("a-tag", { attrs: { color: "red" } }, [
                      _vm._v("Kötelező feladat")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _c(
          "article",
          [
            _vm.article.picture
              ? _c("div", { staticClass: "article-image" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "/api/v1/companies/1/images/" +
                        _vm.article.picture.id +
                        "/view?width=1920",
                      alt: _vm.article.title
                    }
                  })
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "article-content" },
              [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.article.content) }
                }),
                _vm._l(_vm.widgets, function(widget) {
                  return _c(
                    "div",
                    { key: widget.id, staticClass: "article-widget" },
                    [
                      widget.type.code === "gallery" && widget.gallery
                        ? _c(
                            "div",
                            [
                              _c("BulletinGalleryComponent", {
                                attrs: { id: widget.gallery.id }
                              })
                            ],
                            1
                          )
                        : widget.type.code === "content"
                        ? _c("div", {
                            domProps: { innerHTML: _vm._s(widget.content) }
                          })
                        : widget.type.code === "documents"
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "bulletin-documents-container" },
                              _vm._l(widget.documents, function(file) {
                                return _c("BulletinFileComponent", {
                                  key: file.id,
                                  attrs: { file: file }
                                })
                              }),
                              1
                            )
                          ])
                        : widget.type.code === "youtube" && widget.videoId
                        ? _c("div", [
                            _c("iframe", {
                              attrs: {
                                src:
                                  "https://www.youtube.com/embed/" +
                                  widget.videoId,
                                title: "YouTube video player",
                                frameborder: "0",
                                allow:
                                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                referrerpolicy:
                                  "strict-origin-when-cross-origin",
                                allowfullscreen: ""
                              }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                })
              ],
              2
            ),
            _vm.article.mandatory
              ? _c("BulletinReadArticleComponent", {
                  attrs: { id: _vm.article.id }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }